<template>
  <v-radio
    class="sn-radio"
    v-bind="vuetifyOverrideMixin.bindings"
    v-on="$listeners"
  >
    <!-- Pass on all named slots -->
    <slot
      v-for="slot in Object.keys($slots)"
      :slot="slot"
      :name="slot"
    />

    <!-- Pass on all scoped slots -->
    <template
      v-for="slot in Object.keys($scopedSlots)"
      :slot="slot"
      slot-scope="scope"
    >
      <slot
        :name="slot"
        v-bind="scope"
      />
    </template>
  </v-radio>
</template>

<script>
import vuetifyOverrideMixin from '~/components/snui/v2/mixins/vuetifyOverrideMixin.vue'

export default {
  name: 'SnRadio',
  mixins: [vuetifyOverrideMixin],
  data () {
    return {
      vuetifyOverrideMixin: {
        defaultProps: {
          color: 'snPrimary'
        },
        // Supported props: disabled, id, label, name, readonly, value
        overriddenProps: {
          activeClass: 'sn-radio-active',
          dark: false,
          light: false,
          offIcon: '$snRadio',
          onIcon: '$snRadioSelected',
          ripple: false
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/css/snui/index.scss';
@import '~/components/snui/v2/mixins/vuetifyOverrideCss.scss';

.sn-radio::v-deep {
  @extend .sn-selection;
  @extend .sn-selection__input;

  &.sn-radio-active {
    @extend .sn-selection__input-active;
  }
  &:not(.sn-radio-active) {
    @extend .sn-selection__input-inactive;
  }
  &.v-radio--is-disabled {
    @extend .sn-selection__input-disabled;
  }
}

// Only when a 'sn-radio' component is contained within a 'sn-radio-group'
// will the error/disabled/row/column states be supported
.sn-radio-group {
  &.error--text .sn-radio {
    @extend .sn-selection__input-error;
  }
  &.v-input--is-disabled .sn-radio {
    @extend .sn-selection__input-disabled;
  }
  &.v-input--radio-group--row .sn-radio {
    @extend .sn-radio-row;
  }
}

.sn-radio-row {
  flex-grow: 1;
  margin: 0;
  flex-direction: row;
  flex-basis: 0;

  ::v-deep {
    // Share the padding between the label and icon so that they are centered horizontally
    .v-label {
      padding-left: 4px;
      padding-right: 16px;
    }
    .v-icon {
      padding-right: 4px;
      padding-left: 16px;
    }
  }

  ::v-deep .v-input--selection-controls__input {
    flex-grow: 1;
    justify-content: end;
  }

  &:first-child { border-radius: 2px 0 0 2px; }
  &:not(:first-child):not(:last-child) { border-radius: 0; }
  &:last-child { border-radius: 0 2px 2px 0; }

  // Make sure the radio buttons' borders are shared between each other.
  &:not(:first-child) { margin-left: -1px; }

  // To get the shared borders to overlap each other properly, ensure the z-index is respected in order of 1) hovered, 2) active, and 3) inactive.
  &:not(.sn-radio-active):hover { z-index: 2; }
  &.sn-radio-active { z-index: 1; }
  &:not(.sn-radio-active) { z-index: 0; }
}
</style>
